import {validate} from '../../../lib/schema-validator.js'
import {valueSchema, answerSchema} from './schema.js'

export const DATA_POINT_ID = 'none_above_facility_follows_practices_listed_above_regarding'

export const dataPointDefinition = {
  retracedId: 'none_above_facility_follows_practices_listed_above_regarding',
  name: 'None of the above - the facility follows all practices listed above regarding OSH committees',
  description: 'Select "X" if the facility HAS all the practices described above.',
  meta: {
    slcpMeta: {
      key: 'hs-hsc-18x',
      number: 'HS-HSC-9-8',
      dataType: 'boolean',
      masterType: 'Question',
      multiSelectKey: 'hs-hsc-10',
      optionList: 'ms',
      versionImported: '1.7.0',
      verificationTypeReq: 'base-verf',
      verificationSelectionOptList: 'verf-a-list',
      nonComOptionList: 'lf',
      nonCompliance: '',
      humanShowHide: '[2],hs-hsc-1;hs-17,Yes',
      machineShowHide: '[2],hs-hsc-1;hs-17,1',
      completionCondition: 'any ms',
    },
  },
  fieldTypeId: 'SHORT_TEXT',
  type: 'RELATIONAL',
  options: [
    {
      id: 'ms',
      name: 'ms',
    },
  ],
  schema: {
    type: 'object',
    properties: {
      value: {
        type: 'string',
      },
    },
    required: ['value'],
  },
  externalIds: [{id: 'hs-hsc-18x', version: '1.7.0', provider: 'slcp'}],
  sortingId: 31400,
  sectionId: '',
  impactArea: '',
  impactAreaId: '',
}

export const validateSchema = data => {
  try {
    validate({value: data, schema: valueSchema})
    return data
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
export const transformAnswer = (answer, {meta}) => {
  try {
    validate({value: answer, schema: answerSchema})
    const formattedDataPointKey = DATA_POINT_ID.replace(/_([a-z])/g, g => g[1].toUpperCase())
    return {[formattedDataPointKey]: answer}
  } catch (error) {
    throw new Error(`DATA_POINT_ID: ${error}`)
  }
}
